import { Injectable } from '@angular/core';
import { ChangeNotification } from '../models/changeNotification.model';
import * as _ from 'lodash-es';

@Injectable()
export class ChangeNotificationsService {
  private changeNotifications: ChangeNotification[] = [];

  public addNotification(changeNotification: ChangeNotification) {
    const existingIndex = _.findIndex(this.changeNotifications, function (n) {
      return n.changeKey.toLowerCase() === changeNotification.changeKey.toLowerCase();
    });

    if (existingIndex !== -1) {
      this.changeNotifications[existingIndex] = changeNotification;
    } else {
      this.changeNotifications.push(changeNotification);
    }
  }

  public clearNotifications() {
    this.changeNotifications = [];
  }

  get notifications(): ChangeNotification[] {
    return _.filter(this.changeNotifications, function (n) {
      return n.hasChanges === true && n.warningMessage && n.warningMessage.length > 0;
    });
  }

  get isPostProceedActionRequired(): boolean {
    return _.some(this.notifications, function (n) {
      return n.postProceedActionRequired;
    });
  }

  get postProceedActionData(): any {
    //to check effect of commented code below.
    // return _.first(this.notifications, function (n) { return n.postProceedActionRequired; }).postProceedActionData;
    return _.first(this.notifications).postProceedActionData;
  }
  public removeNotificationns(changeKey: string) {
    const existingIndex = _.findIndex(this.changeNotifications, function (n) {
      return n.changeKey.toLowerCase() === changeKey.toLowerCase();
    });
    if (existingIndex > -1) {
      this.changeNotifications.splice(existingIndex, 1);
    }
  }
}
